import { render, staticRenderFns } from "./AbaEnderecoPessoa.vue?vue&type=template&id=ed91dba2"
import script from "./AbaEnderecoPessoa.vue?vue&type=script&lang=js"
export * from "./AbaEnderecoPessoa.vue?vue&type=script&lang=js"
import style0 from "./AbaEnderecoPessoa.vue?vue&type=style&index=0&id=ed91dba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports